import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0035',
    ecrans: ['00-2'],
    params: ['id',
            '?prucleint',
            '?soncleint',
            '?vaesysnatctb',
            '?peccleintdeb',
            '?peccleintfin',
            '?indcleint']
});
